// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zteL43xBrn4osZ {
  display: flex;
  flex-direction: row;
  align-items: center;
  color: var(--ds-text-subtle, #44546f);
  line-height: 12px;
  cursor: pointer;
}
.zteL43xBrn4osZ .JeWYMl9ZBuItYA {
  margin-right: 4px;
}
.zteL43xBrn4osZ .zrUP_qjaq8EjyT {
  font-size: 12px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"privacyLabel": `zteL43xBrn4osZ`,
	"icon": `JeWYMl9ZBuItYA`,
	"labelText": `zrUP_qjaq8EjyT`
};
export default ___CSS_LOADER_EXPORT___;
